<template>
  <div>
    <el-card>
      <div class="add_box">
        <el-form
          :model="this.list"
          :rules="toEdRule"
          :label-position="labelPosition"
          ref="ruleForm"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="跳转的连接"
                prop="linkTo"
                style="margin-right: 15px"
              >
                <el-input
                  placeholder="请输入内容"
                  v-model="list.linkTo"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="显示几秒" prop="showSecond">
                <el-input
                  placeholder="请输入内容"
                  v-model="list.showSecond"
                  clearable
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                label="开屏图(1124×2208)"
                prop="advertisementUrl"
                ref="advertisementUrl"
              >
                <el-upload
                  class="avatar-uploader"
                  :action="serverUrl"
                  :headers="header"
                  name="img"
                  :auto-upload="true"
                  :show-file-list="false"
                  :on-success="upSuccess"
                >
                  <img
                    v-if="list.advertisementUrl"
                    :src="list.advertisementUrl"
                    class="avatar"
                    style="width: 150px; height: auto"
                  />

                  <i
                    :class="
                      loadUpt
                        ? 'el-icon-loading'
                        : 'el-icon-plus avatar-uploader-icon'
                    "
                    style="margintop: 10px; font-size: 50px"
                    v-else
                  ></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-button
              style="margin-left: 600px"
              type="primary"
              @click="submitEdit('ruleForm')"
              >保存</el-button
            >
          </el-row>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  props: ["Changedata"],
  data() {
    return {
      loadUpt: false,
      list: [],
      myHeaders: { token: this.$store.state.token },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      myHeaders: { token: this.$store.state.token },
      labelPosition: "top",
      toEdRule: {
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        // advertisementUrl: [
        //   { required: true, message: "内容不能为空", trigger: "blur" },
        // ],
        zhaiyao: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    upSuccess(file) {
      this.list.advertisementUrl = file.entity;
      if (file.entity) {
        this.$refs.advertisementUrl.clearValidate();
      }
    },
    upSuccessCoverUrl(file) {
      this.list.cover_url = file.entity;
      if (file.entity) {
        this.$refs.advertisementUrl.clearValidate();
      }
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        this.postAxios("/ad/kaiping/update", {
          id: this.list.id,
          advertisementUrl: this.list.advertisementUrl,
          linkTo: this.list.linkTo,
          showSecond: this.list.showSecond,
        }).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (res.success == false && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      });
    },
  },
  mounted() {
    this.list = this.Changedata;
  },
  watch: {
    Changedata(newVal, oldVal) {
      this.list = newVal;
    },
  },
};
</script>
<style scoped lang="less">
/deep/.el-dialog {
  margin-top: 0 !important;
}
/deep/ .el-icon-close {
  font-size: 38px;
  font-weight: bold;
}
</style>